// extracted by mini-css-extract-plugin
export default {"jumbotron":"Jumbotron_jumbotron__VmtGk","btn-orange":"Jumbotron_btn-orange__vP1mT"};